const featureRestrictions = {
    gb: new Set(["swap"]),
};
export function featureRestricted(jurisdiction, feature) {
    return (jurisdiction === undefined ||
        (featureRestrictions[jurisdiction.toLowerCase()]?.has(feature) ?? false));
}
